import Carousel from "../carousel/Carousel";
import {
  WalkthroughContainer,
  WalkthroughHeading,
  WalkthroughTextBox,
  WalkthroughTextBoxTitle,
  WalkthroughTextContainer,
} from "./WalkthroughStyles";

function Walkthrough({ page }) {
  switch (page) {
    case "planning":
      return (
        <WalkthroughContainer>
          <Carousel />
          <WalkthroughTextContainer>
            <WalkthroughHeading>Smart Planners</WalkthroughHeading>
            <WalkthroughTextBox>
              <WalkthroughTextBoxTitle>
                1. Ervaren zorgplanners in alle sectoren
              </WalkthroughTextBoxTitle>
              <p>
                Van thuiszorg en GGZ tot GHZ en ouderenzorg – onze planners zijn
                breed inzetbaar en direct productief.
              </p>
            </WalkthroughTextBox>
            <WalkthroughTextBox>
              <WalkthroughTextBoxTitle>
                2. Directe inzet, minimale inwerktijd
              </WalkthroughTextBoxTitle>
              <p>
                Onze planners zijn bekend met diverse planningssystemen en maken
                zich snel de werkwijze van jouw organisatie eigen.
              </p>
            </WalkthroughTextBox>
            <WalkthroughTextBox>
              <WalkthroughTextBoxTitle>
                3. Volledige ondersteuning en continuïteit
              </WalkthroughTextBoxTitle>
              <p>
                Of het nu gaat om ziekte, verlof of een plotseling vertrek, wij
                zorgen voor een snelle en betrouwbare oplossing.
              </p>
            </WalkthroughTextBox>
            <WalkthroughTextBox>
              <WalkthroughTextBoxTitle>
                4. Slimme planning met Smart-Personeel
              </WalkthroughTextBoxTitle>
              <p>
                We bieden niet alleen tijdelijke oplossingen, maar denken ook
                mee over structurele verbeteringen in de planning.
              </p>
            </WalkthroughTextBox>
          </WalkthroughTextContainer>
        </WalkthroughContainer>
      );
    case "crisis":
      return (
        <WalkthroughContainer>
          <Carousel />
          <WalkthroughTextContainer>
            <WalkthroughHeading>Het Smart Team</WalkthroughHeading>
            <WalkthroughTextBox>
              <WalkthroughTextBoxTitle>
                1. Volledige ontzorging
              </WalkthroughTextBoxTitle>
              <p>
                Van het roosteren van diensten tot het beheren van contracten en
                het opstellen van zorgplannen: wij nemen alles uit handen. Dit
                zorgt voor rust, zodat u zich kunt concentreren op de zorg zelf
              </p>
            </WalkthroughTextBox>
            <WalkthroughTextBox>
              <WalkthroughTextBoxTitle>
                2. 1 op 1 begeleiding
              </WalkthroughTextBoxTitle>
              <p>
                Soms is individuele aandacht precies wat een cliënt nodig heeft.
                Onze begeleiders ondersteunen cliënten met uiteenlopende
                hulpvragen, van gedragsproblematiek en autisme tot intensieve
                zorgbehoeften
              </p>
            </WalkthroughTextBox>
            <WalkthroughTextBox>
              <WalkthroughTextBoxTitle>3. Teamleiders</WalkthroughTextBoxTitle>
              <p>
                Smart teamleiders sturen teams aan, verbeteren werkprocessen en
                bewaken de continuïteit van zorg. Met hun ervaring en
                leiderschap zorgen ze voor structuur en stabiliteit.
              </p>
            </WalkthroughTextBox>
            <WalkthroughTextBox>
              <WalkthroughTextBoxTitle>
                4. Individuele clientondersteuning
              </WalkthroughTextBoxTitle>
              <p>
                Onze planners nemen de volledige planning uit handen en zorgen
                voor een soepel rooster zonder tekorten. Zo blijft de
                continuïteit gewaarborgd en de werkdruk beheersbaar.
              </p>
            </WalkthroughTextBox>
          </WalkthroughTextContainer>
        </WalkthroughContainer>
      );
    default:
      return (
        <WalkthroughContainer>
          <Carousel />
          <WalkthroughTextContainer>
            <WalkthroughHeading>Hoe Smart werkt</WalkthroughHeading>
            <WalkthroughTextBox>
              <WalkthroughTextBoxTitle>1. Snel Contact</WalkthroughTextBoxTitle>
              <p>
                Hoe eerder we je spreken, hoe beter. Zo vinden we snel een
                oplossing voor jouw zorgvraagstuk.
              </p>
            </WalkthroughTextBox>
            <WalkthroughTextBox>
              <WalkthroughTextBoxTitle>
                2. Vast Aanspreekpunt
              </WalkthroughTextBoxTitle>
              <p>
                We houden van korte lijntjes. Daarom krijg je één vast
                aanspreekpunt, die jouw zorgorganisatie leert kennen.
              </p>
            </WalkthroughTextBox>
            <WalkthroughTextBox>
              <WalkthroughTextBoxTitle>
                3. Perfecte Match
              </WalkthroughTextBoxTitle>
              <p>
                We matchen de zorgprofessional met expertise en de juiste
                persoonlijkheid aan jouw zorgvraagstuk.
              </p>
            </WalkthroughTextBox>
            <WalkthroughTextBox>
              <WalkthroughTextBoxTitle>
                4. Blijven Betrokken
              </WalkthroughTextBoxTitle>
              <p>
                We laten je niet zwemmen. Smart blijft betrokken. Samen met jou
                monitoren we continu de geleverde kwaliteit.
              </p>
            </WalkthroughTextBox>
          </WalkthroughTextContainer>
        </WalkthroughContainer>
      );
  }
}

export default Walkthrough;
